import { render } from "./IAlbum.vue?vue&type=template&id=6b6d53a6"
import script from "./IAlbum.vue?vue&type=script&lang=js"
export * from "./IAlbum.vue?vue&type=script&lang=js"

import "./IAlbum.vue?vue&type=style&index=0&id=6b6d53a6&lang=sass"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__